<template>    
    <BaseModal
        :id="modal_name"
        :title="`${title}${subtitle ?subtitle : ''}`"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                    :content_align_x="'justify-content-start'"
                />
                <div class="d-flex align-items-right justify-content-end">
                    <a :class="{'disabled button__disabled' : !form_data.completed_date}" type="submit" class="mx-md-0 modal__buttons__item mt-3 h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Complete'" @click="form_data.completed_date ? complete() : null" v-if="!loader_button"/>

                        <div class="spinner-border mt-2 mr-4" role="status" v-else>
                            <span class="sr-only">Loading...</span>
                        </div>
                </div>
                <div class="table-responsive table-fix-head horizontal-scroll-reports" :style="`max-height: 35rem`"  v-if="!loader_list">
                    <table class="table">
                        <thead>
                            <tr style="background-color: #fff">
                            <th
                                style="font-weight: normal !important"
                                class="header-item-manual"
                                v-for="(item, i) in table_headers"
                                :key="i"
                                scope="col"
                                v-html="item.text"
                            />
                            </tr>
                        </thead>
                        <tbody>
                            <template>
                            <tr v-for="(completed_date, i) in completed_dates" :key="i">
                                <td class="va-bottom">
                                    <div class="formdynamic__item__field">
                                        <!-- <b style="color:red;">*</b> -->
                                        <input type="date" v-model="completed_date.last_completed_raw_date" :disabled="completed_date.disabled">
                                    </div>
                                </td>
                                <td class="va-bottom">
                                    <div class="formdynamic__item__field">
                                        <input pattern=".*" type="number" v-model="completed_date.actual_minutes" :disabled="completed_date.disabled">
                                    </div>
                                </td>
                                <td class="va-bottom">
                                    <div class="formdynamic__item__field">
                                        <select size="" class="input-field custom-select" v-model="completed_date.associate_id" :disabled="completed_date.disabled">
                                            <option value="">Select an option</option>
                                            <option v-for="(associate, i) in array_options.associate_id" :key="i" :value="associate.id" v-html="associate.associate_name"/>
                                        </select>
                                    </div>
                                </td>
                                <td class="va-bottom">
                                    <div class="formdynamic__item__field">
                                        <input pattern=".*" type="text" v-model="completed_date.comment" :disabled="completed_date.disabled">
                                    </div>
                                </td>
                                <td class="va-bottom" v-html="completed_date.project_name"/>
                                <td class="va-bottom">
                                        <button
                                            type="button"
                                            class="modal__buttons__item"
                                            v-html="`${completed_date.disabled ? 'Edit' : 'Done'}`"
                                            style="width: 3rem"
                                            @click="changeDisabled(completed_date, i)"
                                            :disabled="i === loader_item_index"
                                        />
                                        <button
                                            type="button"
                                            class="modal__buttons__item btn-light"
                                            style="color: #212529; background-color: #f8f9fa; border-color: #f8f9fa; width: 3rem;"
                                            v-html="'Delete'"
                                             :disabled="i === loader_item_index"
                                            @click="deleteCompletion(completed_date, i)"
                                        />
                                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-center" v-else>
                    <div class="spinner-border mt-2 mr-4" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <CentralLiteButtons
                    :done="true"
                />
            </form>
        </template>
    </BaseModal>
</template>

<script>

// import FormResources        from    './form_resources'
import FormDynamic          from    '@/components/FormDynamic.vue'
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons.vue'
import eventBus             from    '@/plugins/eventBus'
import FormResources from './form_resources';
import Resources from './resources';

export default {

    name:   'ProjectCompleteModal',

    props: [
        'title',
        'rest_api',
        'notyf',
        'breadcrumb',
        'subtitle'
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data() {
        return {
            modal_name:         'static-project-complete',
            form_format:        FormResources.form_format_complete_project,
            form_data:          FormResources.complete_project_form_data,
            form_backup:        {...FormResources.complete_project_form_data},
            array_options: {
                associate_id: []
            },
            table_headers:        Resources.table_headers_project_complete,
            single_object: {},
            completed_dates: [],
            loader_button: false,
            loader_list: false,
            loader_item_index: -1,
            key: 'decrypted_id'
        }
    },

    watch:{

    },

    methods:
    {
        async changeDisabled(completed_date, index)
        {
            if(completed_date.disabled)
            {
                completed_date.disabled = false
                return
            }

            this.loader_item_index = index

            const res = await this.put(`${this.rest_api}/${completed_date.project_project_scheduler_id}`, completed_date)

            this.loader_item_index = -1

            if(res.status)
            {
                this.notyfMesg('Success')
                completed_date.disabled = true      
            }
            else
            {
                this.error_handling(res)
            }
        },

        async deleteCompletion(completed_date, index)
        {
            this.loader_item_index = index

            const res = await this.delete(`${this.rest_api}/${completed_date.project_project_scheduler_id}`)

            this.loader_item_index = -1

            if(res.status)
            {
                this.notyfMesg('Success') 
                this.completed_dates.splice(index, 1)    
            }
            else
            {
                this.error_handling(res)
            }
        },

        async getInitialData(room_task, key = 'decrypted_id') 
        {
            this.key = key
            this.single_object = room_task

            this.loader_list = true

            const res = await this.get(`${this.rest_api}/${this.single_object[this.key]}`)

            this.loader_list = false

            if(res.status)
            {
                this.completed_dates = res.data.completed_dates
                this.array_options = {
                    associate_id: res.data.associate_id
                }
            }
            else
            {
                this.error_handling(res)
            }
        },

        async complete()
        {
            this.loader_button = true

            this.form_data.room_task_id = this.single_object[this.key]

            const res = await this.post(`${this.rest_api}`, this.form_data)

            if(res.status)
            {
                this.completed_dates.unshift(res.data.new)
                this.notyfMesg('Room task was completed successfully')
                this.form_data = {...this.form_backup}
            }
            else
            {
                this.error_handling(res)
            }

            this.loader_button = false
            
        },

    },

    mounted()
    {
        eventBus.$on('saveAndNew', () => 
        {
            this.save_and_new = false
        })
    },
    
}
</script>
